"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecordIdFieldLogic = exports.getTextValueForClipboard = exports.RECORD_ID_FIELD_SYSTEM_SLUG = void 0;
const types_1 = require("@smartsuite/types");
const field_logic_1 = require("../../field-type-registry/field-logic");
const comparisons_1 = require("../../comparisons/comparisons");
const detailed_decimal_1 = require("../../formatters/detailed-decimal");
const record_id_fieldtype_1 = require("../../safe-field-value/record-id-field/record-id.fieldtype");
const texts_1 = require("../../texts");
const intl_1 = require("../../locale/intl");
exports.RECORD_ID_FIELD_SYSTEM_SLUG = "id";
/**
 * Returns absolute url to edit record page
 */
const getTextValueForClipboard = (recordId) => {
    const url = window.location.href.split("?")[0]; // url without query parameters
    return `${url}?${types_1.recordQueryParamName}=${recordId}`;
};
exports.getTextValueForClipboard = getTextValueForClipboard;
class RecordIdFieldLogic extends field_logic_1.BaseFieldTypeLogic {
    constructor() {
        super(...arguments);
        this.name = "recordidfield";
        this.label = (0, intl_1.$t)(texts_1.recordIdFieldText.record_id);
        this.icon = "record-id";
        this.iconColor = "#6A849B";
        this.placeholder = (0, intl_1.$t)(texts_1.recordIdFieldText.enter_number_here);
        this.searchSynonyms = [
            (0, intl_1.$t)(texts_1.recordIdFieldText.guid),
            (0, intl_1.$t)(texts_1.recordIdFieldText.unique),
        ];
        // @ts-expect-error: Need to resolve
        this.comparisons = {
            is: comparisons_1.is,
            is_not: comparisons_1.isNot,
            contains: comparisons_1.contains,
            not_contains: comparisons_1.notContains,
            // member directory filters - online/offline
            is_any_of: comparisons_1.isAnyOf,
            is_none_of: comparisons_1.isNoneOf,
        };
        this.gridOptions = {
            isMouseTextSelectAvailable: true,
        };
        this.lookupMode = "lookup";
        this.fieldValueGetter = new record_id_fieldtype_1.RecordIdFieldValueGetter();
    }
    prepareValueForClipboard(fieldValue, field, _userPreferences) {
        return {
            text: (0, exports.getTextValueForClipboard)(fieldValue),
            rawValue: this.valueToString(fieldValue, field),
        };
    }
    canDelete(field) {
        return field.slug !== exports.RECORD_ID_FIELD_SYSTEM_SLUG;
    }
    canModifySettings(_field) {
        return true;
    }
    processFieldValue(record, slug, comparison, field) {
        const value = super.processFieldValue(record, slug, comparison, field);
        return this.valueToString(value, field);
    }
    valueToString(fieldValue, field) {
        var _a, _b;
        return (0, detailed_decimal_1.addLabels)(fieldValue, (_a = field.params.prefix) !== null && _a !== void 0 ? _a : "", (_b = field.params.suffix) !== null && _b !== void 0 ? _b : "");
    }
    showSystemLockIcon() {
        return true;
    }
    getInlineEditRules(field) {
        return {
            ...super.getInlineEditRules(field),
            allowAddRecordToGroup: false,
        };
    }
    getCommonFieldParams(field) {
        return { ...super.getCommonFieldParams(field), system: false };
    }
    canChangeValue() {
        return false;
    }
    getLinkedRecordFieldSmartWidth(_field) {
        return {
            defaultWidht: 90,
            minWidth: 45,
        };
    }
    isSupportedByBulkAction() {
        return false;
    }
}
exports.RecordIdFieldLogic = RecordIdFieldLogic;
